import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock, ArrowRight } from "lucide-react";

export const MembershipCta = () => {
  const { user } = useAuth();
  if (!user || user.is_member) return null;
  return (
    <Link to="/membership" className="card card-interactive concrete relative overflow-hidden flex items-center justify-between gap-4 mb-8" style={{ borderColor: "#FF0055" }} data-testid="membership-cta">
      <div className="relative z-10 flex items-center gap-4">
        <div className="w-11 h-11 flex items-center justify-center shrink-0" style={{ background: "#FF0055" }}>
          <Lock size={18} color="white" />
        </div>
        <div>
          <p className="eyebrow" style={{ color: "#FF0055" }}>Unlock everything</p>
          <p className="font-display font-bold text-base md:text-lg mt-1 uppercase">Become a CINDR member — $19.99 CAD/mo</p>
          <p className="text-xs text-zinc-400 mt-1">Full program, workout library, AI coach & recipes. Cancel anytime.</p>
        </div>
      </div>
      <ArrowRight size={18} color="#FF0055" className="relative z-10" />
    </Link>
  );
};
